import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';

const STORAGE_KEY = 'themeOverride';
const EXPIRY_KEY = 'themeOverrideExpiry';
const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000; // 12 horas en milisegundos

// Obtener el override guardado (si no ha expirado)
export const getThemeOverride = async () => {
  try {
    let value = null;
    let expiry = null;
    
    if (Platform.OS === 'web') {
      value = typeof localStorage !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
      expiry = typeof localStorage !== 'undefined' ? localStorage.getItem(EXPIRY_KEY) : null;
    } else {
      value = await AsyncStorage.getItem(STORAGE_KEY);
      expiry = await AsyncStorage.getItem(EXPIRY_KEY);
    }
    
    // Verificar si ha expirado
    if (expiry) {
      const expiryTime = parseInt(expiry, 10);
      if (Date.now() > expiryTime) {
        // Ha expirado, limpiar
        await clearThemeOverride();
        return null;
      }
    } else if (value) {
      // Hay valor pero no expiry (migración), limpiar
      await clearThemeOverride();
      return null;
    }
    
    return value === 'light' || value === 'dark' ? value : null;
  } catch {
    return null;
  }
};

// Guardar override con expiración de 12 horas
export const setThemeOverride = async (value) => {
  try {
    if (value !== 'light' && value !== 'dark' && value !== null) return false;
    
    if (value === null) {
      await clearThemeOverride();
      return true;
    }
    
    const expiryTime = Date.now() + TWELVE_HOURS_MS;
    
    if (Platform.OS === 'web') {
      localStorage.setItem(STORAGE_KEY, value);
      localStorage.setItem(EXPIRY_KEY, expiryTime.toString());
      try {
        if (typeof globalThis !== 'undefined') {
          globalThis.__THEME_OVERRIDE__ = value;
        }
      } catch {}
    } else {
      await AsyncStorage.setItem(STORAGE_KEY, value);
      await AsyncStorage.setItem(EXPIRY_KEY, expiryTime.toString());
      try {
        if (typeof globalThis !== 'undefined') {
          globalThis.__THEME_OVERRIDE__ = value;
        }
      } catch {}
    }
    return true;
  } catch {
    return false;
  }
};

// Limpiar override (volver al sistema)
export const clearThemeOverride = async () => {
  try {
    if (Platform.OS === 'web') {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.removeItem(EXPIRY_KEY);
      try {
        if (typeof globalThis !== 'undefined') {
          globalThis.__THEME_OVERRIDE__ = null;
        }
      } catch {}
    } else {
      await AsyncStorage.removeItem(STORAGE_KEY);
      await AsyncStorage.removeItem(EXPIRY_KEY);
      try {
        if (typeof globalThis !== 'undefined') {
          globalThis.__THEME_OVERRIDE__ = null;
        }
      } catch {}
    }
    return true;
  } catch {
    return false;
  }
};

// Obtener esquema efectivo (sync, para uso en hooks)
export const getEffectiveScheme = (systemScheme, override) => {
  if (override === 'light' || override === 'dark') return override;
  return systemScheme || 'light';
};
